import React from "react";
var __jsx = React.createElement;
import stl from "./MarkitingLabel.module.css";
var MarkitingLabel = function MarkitingLabel(_ref) {
  var campaign = _ref.campaign,
    HorizontalCarCardDesignClasses = _ref.HorizontalCarCardDesignClasses;
  return /*#__PURE__*/React.createElement("div", {
    className: HorizontalCarCardDesignClasses !== null && HorizontalCarCardDesignClasses !== void 0 ? HorizontalCarCardDesignClasses : stl.markitingLabel,
    style: {
      backgroundColor: campaign.bg_color
    }
  }, /*#__PURE__*/React.createElement("span", null, campaign.txt));
};
export default MarkitingLabel;